import React, { useState } from "react";

import OtpInput from "react-otp-input";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Loader2 } from "lucide-react";

const AuthenticateTwoFA = ({ onVerify, onCancel, isVerifying }) => {
  const [otp, setOtp] = useState("");

  const handleChange = (otp) => {
    setOtp(otp);
  };
  return (
    <Card className="bg-white rounded-2xl border-none shadow-none overflow-hidden">
      <CardContent className="pt-10 pb-8 px-10">
        <div className="flex flex-col justify-center mb-8">
          <h3 className="text-[32px] font-semibold text-left text-[#57249C] mb-2">
            Verify 2-Factor Authentication
          </h3>
          <p className="text-[#423E51] text-[20px]">
            Enter the 6-digit verification code generated by your authentication
            app:
          </p>
        </div>

        <div className="space-y-2 mb-10 mx-auto w-fit">
          <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            separator={<span>-</span>}
            shouldAutoFocus
            renderInput={(props) => (
              <input
                {...props}
                className="w-[56px] h-[56px] text-xl font-bold text-center border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-500 hover:border-purple-400 transition-all outline-none"
              />
            )}
            inputStyle={{
              width: "40px",
              height: "40px",
              margin: "0 5px",
              fontSize: "18px",
              borderRadius: "12px",
              border: "1px solid hsl(var(--border))",
              textAlign: "center",
            }}
            focusStyle={{
              border:
                "1px solid bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90",
            }}
          />
        </div>
        <div className="flex items-center justify-center gap-3">
          <Button
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
            }}
            variant="outline"
            className="rounded-full text-[20px] py-6 px-24 w-[48%] text-[#6D6584] font-semibold bg-white hover:opacity-90 h-[64px] disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isVerifying}
          >
            Back
          </Button>
          <Button
            onClick={() => {
              if (onVerify) {
                onVerify(otp);
              }
            }}
            variant="outline"
            className="bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity w-[48%] text-[20px] h-[64px] disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isVerifying || otp.length !== 6}
          >
            {isVerifying && <Loader2 className="animate-spin w-4 h-4 mr-2" />}
            {isVerifying ? "Verifying..." : "Verify and Activate"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AuthenticateTwoFA;
